<template>
  <div class="ai-module-content">
    <div
      v-if="module.isHtml || module.type === 'deepInsight'"
      class="html-content"
      v-dompurify-html="module.content"
    ></div>
    <p v-else>{{ module.content }}</p>
    <div class="footer">免责声明：该内容由AI生成，仅供参考。</div>
  </div>
</template>

<script>
export default {
  name: 'AiSummary',
  props: {
    module: {
      default: () => ({})
    },
  },
};
</script>

<style lang="less" scoped>
.ai-module-content {
  padding: 0 15px;
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  white-space: pre-line;
  word-break: break-all;

  p {
    margin: 0;
  }

  .html-content {
    white-space: normal;
    overflow: visible;

    /deep/ p {
      margin: 0 0 8px;
    }

    /deep/ h1,
    /deep/ h2,
    /deep/ h3,
    /deep/ h4,
    /deep/ h5,
    /deep/ h6 {
      margin: 0 0 8px;
      line-height: 24px;
    }

    /deep/ br {
      display: none;
    }

    /deep/ img {
      max-width: 100%;
      height: auto;
    }

    /deep/ table {
      max-width: 100%;
      width: 100%;
      border-collapse: collapse;
    }

    /deep/ ul,
    /deep/ ol {
      margin: 0 0 8px;
      padding-left: 20px;
    }

    /deep/ li {
      margin: 0 0 6px;
    }
  }

  .footer {
    padding: 12px 0 0;
    color: #999999;
    font-size: 12px;
    line-height: 18px;
  }
}

.night .ai-module-content {
  color: #D2D2D3;

  .footer {
    color: #999999;
  }
}
</style>
